import { render, staticRenderFns } from "./product.component.vue?vue&type=template&id=f5d33290"
import script from "./product.component.vue?vue&type=script&lang=js"
export * from "./product.component.vue?vue&type=script&lang=js"
import style0 from "./product.component.vue?vue&type=style&index=0&id=f5d33290&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports